<template>
  <v-container class="pt-6" >
    <!--  delete display style after more fun will be available -->
    <v-card class="elevation-12 mb-6" style='display: none;'>
      <v-card-title class="px-9 pt-7">
        Aktualizace RSD VN
      </v-card-title>

      <v-card-text class="px-9">
        <v-radio-group v-model="requestType" class="d-inline">
            <v-row>
              <v-col cols="12" md="6">
                <v-radio
                  label="Změna rezervované kapacity"
                  value="CHANGE_RESERVED_CAPACITY"
                ></v-radio>
              </v-col>
<!--              <v-col cols="12" md="6">-->
<!--                <v-radio-->
<!--                  label="Změna v regulačních stupních"-->
<!--                  value="CHANGE_CONTROL_STAGES"-->
<!--                  ></v-radio>-->
<!--              </v-col>-->
            </v-row>
<!--            <v-row>-->
<!--              <v-col cols="12" md="6">-->
<!--                <v-radio-->
<!--                  label="Změna rezervovaného příkonu"-->
<!--                  value="CHANGE_RESERVED_POWER"-->
<!--                ></v-radio>-->
<!--              </v-col>-->
<!--              <v-col cols="12" md="6">-->
<!--                <v-radio-->
<!--                  label="Ostatní"-->
<!--                  value="OTHER_CHANGE"-->
<!--                ></v-radio>-->
<!--              </v-col>-->
<!--            </v-row>-->
          </v-radio-group>
      </v-card-text>
    </v-card>

    <ChangeOfReservedCapacity v-if="requestType === 'CHANGE_RESERVED_CAPACITY'"/>

    <ChangeOfControlStages v-if="requestType === 'CHANGE_CONTROL_STAGES'"/>

    <ChangeOfReservedPower v-if="requestType === 'CHANGE_RESERVED_POWER'"/>

    <OtherChanges v-if="requestType === 'OTHER_CHANGE'"/>
  </v-container>
</template>

<script>
import ChangeOfReservedCapacity from '../capacity/ChangeOfReservedCapacity.vue';
import ChangeOfControlStages from '../control-stages/ChangeOfControlStages.vue';
import ChangeOfReservedPower from '../power/ChangeOfReservedPower.vue';
import OtherChanges from '../other/OtherChanges.vue';

export default {
  name: 'UpdateFrameworkContractsVN',
  components: {
    ChangeOfReservedCapacity,
    ChangeOfControlStages,
    ChangeOfReservedPower,
    OtherChanges,
  },
  data() {
    return {
      requestType: 'CHANGE_RESERVED_CAPACITY',
    };
  },
};
</script>
